import type {
  FieldUpdate,
  FieldUpdateConfig,
} from '@cdw-ae/common-ui-components-bulk-field-update';
import type { Job } from '@cdw-ae/job-service';
import { createAction, props } from '@ngrx/store';
import type { FieldUpdatesSummary } from '../models/bulk-update-action-models';
import {
  BulkUpdateActions,
  type CdwBulkUpdateActionEntity,
} from './cdw-bulk-update-action.models';

export const initCdwBulkUpdateActions = createAction(
  '[CdwBulkUpdateAction Page] Init'
);

export const loadCdwBulkUpdateActionsSuccess = createAction(
  '[CdwBulkUpdateAction/API] Load CdwBulkUpdateActions Success',
  props<{ cdwBulkUpdateActions: CdwBulkUpdateActionEntity[] }>()
);

export const loadCdwBulkUpdateActionsFailure = createAction(
  '[CdwBulkUpdateAction/API] Load CdwBulkUpdateActions Success',
  props<{ error: unknown }>()
);

export const addBulkUpdateAction = createAction(
  '[CdwBulkUpdateAction/API] Add BulkUpdateAction',
  props<CdwBulkUpdateActionEntity>()
);

export const removeBulkUpdateAction = createAction(
  '[CdwBulkUpdateAction/API] Remove BulkUpdateAction',
  props<{ id: string }>()
);

export const disableBulkUpdateActionNextbutton = createAction(
  '[CdwBulkUpdateAction/API] disable next button',
  props<{ id: string }>()
);

export const enableBulkUpdateActionNextbutton = createAction(
  '[CdwBulkUpdateAction/API] enable next button',
  props<{ id: string }>()
);

export const displayCancellingBulkUpdateAction = createAction(
  '[CdwBulkUpdateAction/API] show cancel bulk update in progresss',
  props<{ id: string }>()
);

export const hideCancellingBulkUpdateAction = createAction(
  '[CdwBulkUpdateAction/API] hide cancel bulk update in progress',
  props<{ id: string }>()
);

export const getBulkUpdateActionJob = createAction(
  BulkUpdateActions.getBulkUpdateActionJob,
  props<{ id: string; customerId: string; jobId: string | undefined }>()
);

export const unsubscribeBulkUpdateActionJob = createAction(
  BulkUpdateActions.unsubscribeBulkUpdateActionJob
);

export const getBulkUpdateActionSuccess = createAction(
  BulkUpdateActions.getBulkUpdateActionSuccess,
  props<{ id: string; job: Job | undefined }>()
);

export const getFieldUpdatesSummary = createAction(
  BulkUpdateActions.getFieldUpdatesSummary,
  props<{
    id: string;
    fieldUpdatesComponents: {
      fieldUpdate: FieldUpdate;
      fieldUpdateConfig: FieldUpdateConfig;
    }[];
  }>()
);

export const getFieldUpdatesSummarySuccess = createAction(
  BulkUpdateActions.getFieldUpdatesSummarySuccess,
  props<{ id: string; summary: FieldUpdatesSummary[] }>()
);
